<h2 mat-dialog-title>Create party</h2>
<mat-dialog-content [formGroup]="form">
  <div class="manage-accounts">
    <mat-form-field>
      <mat-label>Party name</mat-label>
      <input matInput formControlName="name" />
      @if (form.get('name')?.hasError('required')) {
        <mat-error>This field is required</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Party number</mat-label>
      <input matInput formControlName="number" maxlength="9" />
      @if (form.get('number')?.hasError('required')) {
        <mat-error>This field is required</mat-error>
      } @else if (form.get('number')?.hasError('partyNumberFormat')) {
        <mat-error>Party number must be exactly 9 digits</mat-error>
      } @else if (form.get('number')?.hasError('partyNumberPrefix')) {
        <mat-error>Party number must start with 1 or 2</mat-error>
      } @else if (form.get('number')?.hasError('partyNumberExcluded')) {
        <mat-error>This party number is not permitted</mat-error>
      }
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  @if (saving) {
    <button mat-flat-button disabled>Creating</button>
  } @else {
    <button mat-flat-button [disabled]="form.invalid" (click)="create()">Create</button>
  }
</mat-dialog-actions>
